<script>
export default {
  name: "KolonneSettingsVehiclesListItem",

  props: {
    active: {
      type: Boolean,
      default: false
    },
    vehicle: {
      type: Object | null,
      default: null
    },
    selectedKolonneId: {
      type: Number | String,
      default: ''
    },
    startdate: {
      type: String, // format "YYYY-MM-DD"
      default: '',
    },
    kolonneContent: {
      type: Array,
      default: () => [],
    },
    hideRanking: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      isActive: this.active,
    };
  },

  computed: {
    /* shouldShowCategoryName () {
      return !!this.vehicle.categoryName && this.vehicle.name !== this.vehicle.categoryName;
    }, */

    ranking () {
      if (this.isAssignedInOtherWeek) {
        return 'red';
      }

      return 'green';
    },

    isAssignedInOtherWeek () {
      return this.kolonnenNumbersOfOtherWeekAssignments.length > 0;
    },

    kolonnenNumbersOfOtherWeekAssignments () {
      return this.kolonneContent
        .filter(content => content.id !== this.selectedKolonneId)
        .filter(content => [].concat(content.fleet_ids ?? []).includes(this.vehicle.id))
        .map(content => content.kolonne);
    },
  },

  watch: {
    active(newVal) {
      this.isActive = newVal
    },
  },

  methods: {
    onActiveChange() {
      this.$emit('activeChanged', this.vehicle.id, this.isActive)
    }
  },
};
</script>

<template>
  <div class="cell small-6">
    <label>
      <input
        type="checkbox"
        v-model="isActive"
        class="u-no-margin--bottom"
        @change="onActiveChange"
        />
      <i></i>

      <span
        v-if="!hideRanking"
        :title="kolonnenNumbersOfOtherWeekAssignments.join(', ')"
        :class="'c-ranking c-ranking--' + (ranking || 'none') ">
      </span>
      
        {{ vehicle.displayName }}
    
      <p
        v-if="!hideRanking && kolonnenNumbersOfOtherWeekAssignments.length"
        class="u-no-margin u-text-medium u-text-normal u-text-transform-none"
      >
        {{ $t('kolonne.label.assigned.to.other.kolonnen') }} {{ kolonnenNumbersOfOtherWeekAssignments.join(', ') }}
      </p>
      </label>
  </div>
</template>

